import React, { Component } from "react";
import { Table } from "reactstrap";
import AdminCursoModal from "./AdminCursoModal";
import AdminCursoRemovalModal from "./AdminCursoRemovalModal"
import { formatNumber } from "../../utils";

class AdminCursoList extends Component {

    componentDidMount() {
    }  
    
    render() {
      const { ingresoProyecto, admins, proyectoMoneda } = this.props;
      const ingreso = Number(ingresoProyecto) || 0;

      return (
        <div>
          <Table responsive hover striped bordered> 
            <thead>
              <tr className="table-danger">
                <th>Admin del Curso</th>
                <th>Cantidad</th>
                <th>Porcentaje de Commission</th>
                <th>Moneda</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {!admins || admins.length <= 0 ? (
                <tr>
                  <td colSpan="15" align="center">
                    <b>Ups, todavia no hay Admin de este curso!!</b>
                  </td>
                </tr>
              ) : (
                admins.map(admin => {
                  const sub = Number(admin.subcantidad) || 0;
                  const pct = ingreso > 0 ? (sub / ingreso * 100) : 0;
                  return (
                  <tr key={admin.pk}>
                    <td>{admin.instructor}</td>
                    <td>{formatNumber(sub)}</td>
                    <td>{pct.toFixed(2)}%</td>
                    <td>{admin.moneda}</td>
                    <td align="center">
                        <AdminCursoModal
                          create={false}
                          admin={admin}
                          resetState={this.props.resetState}
                          partners={this.props.partners}
                          proyectoCodeSelected={this.props.proyectoCodeSelected}
                          proyectoNameSelected={this.props.proyectoNameSelected}
                          proyectoMoneda={proyectoMoneda}
                          ingresoProyecto={ingresoProyecto}
                        />
                        &nbsp;&nbsp;
                        <AdminCursoRemovalModal
                          pk={admin.pk}
                          resetState={this.props.resetState}
                        />
                    </td>
                  </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      );
    }
  }
  
  export default AdminCursoList;